import { createContext } from "react";
import { SupportedSocialMediaContextProps } from "./supported-social-media-context";

const SupportedSocialMediaContext = createContext<SupportedSocialMediaContextProps>({ socialMedia: [] });

export default SupportedSocialMediaContext;
